import {
  ITransform,
  parseArray,
  parseNumber,
  parseString,
  transformModel,
} from '~/src/dash/api/resource-transforms';
import { addDomainAndTokenToUrl, IHttpResponse, restPost } from '~/src/dash/api/rest';

export interface ICreativeValidation {
  ID: number;
  CreatedAt?: string;
  UpdatedAt?: string;
  DeletedAt?: string;

  OriginalCreativeURL: string;
  CreativeURL: string;
  Adomain: string;
  IABCategory: string;
  PublisherID: number;
  Impressions: number;
  BidErrors: number;
  BidErrorBlockedResponses: number;
  BidErrorsBrandSafety: number;
  BidderID: number;
  TotalCount: number;
  ReviewStatus: number;
  Notes: string;
  AdomainOverride: string;
  IABCategoryOverride: string;
  BrandSafetyRuleIDs: number[];
}

export const REVIEW_STATUS_BLOCKED_BY_API: number = 4;
export const REVIEW_STATUS_ALLOWED: number = 3;
export const REVIEW_STATUS_BLOCKED: number = 2;
export const REVIEW_STATUS_REVIEWED: number = 1;
export const REVIEW_STATUS_UNREVIEWED: number = 0;

// |------------------ CreativeValidation Transformations ------------------|
const transformCreativeValidationToApiConfig: ITransform = {
  OriginalCreativeURL: parseString(['OriginalCreativeURL']),
  CreativeURL: parseString(['CreativeURL']),
  Adomain: parseString(['Adomain']),
  IABCategory: parseString(['IABCategory']),
  PublisherID: parseNumber(['PublisherID']),
  ReviewStatus: parseNumber(['ReviewStatus']),
  BidderID: parseNumber(['BidderID']),
  Notes: parseString(['Notes']),
  AdomainOverride: parseString(['AdomainOverride']),
  IABCategoryOverride: parseString(['IABCategoryOverride']),
  BrandSafetyRuleIDs: parseArray(['BrandSafetyRuleIDs'], (obj: any) => {
    return obj;
  }),
};

// |------------------ Creative Validation API CALLS ------------------|
export const transformCreativeValidationToApi = transformModel<ICreativeValidation>(
  transformCreativeValidationToApiConfig,
);

export async function getCreativeValidationsV2(
  publisherID: string,
  review_status: number,
  creativeValidation: { [key: string]: any },
): Promise<ICreativeValidation[]> {
  const reqUrl = addDomainAndTokenToUrl(
    `/publishers/${publisherID}/creative_validation/` + review_status,
  );
  return await restPost<ICreativeValidation[]>(reqUrl, creativeValidation).then(
    (val: IHttpResponse<ICreativeValidation[]>) => {
      return val.parsedBody || [];
    },
  );
}

// Post Update ReviewStatus for given creative_url and publisher_id
// /publishers/{publisherID}/update_creative_validations
export async function updateCreativeValidation(
  publisherID: string,
  creativeValidation: Partial<ICreativeValidation>,
): Promise<ICreativeValidation | undefined> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/${publisherID}/update_creative_validation`);
  const parsedCreativeValidation = transformCreativeValidationToApi(creativeValidation);
  return await restPost<ICreativeValidation>(reqUrl, parsedCreativeValidation).then(
    (val: IHttpResponse<ICreativeValidation>) => {
      return val.parsedBody;
    },
  );
}
